import { getSessionStatus } from '../lib/session';

export const EXPIRED_SAVE_MSG =
  'Session expired: reload the page before saving. Your changes have not been sent.';

/** True when a save MUST be refused because the JWT session is expired. */
export function isSaveBlockedByExpiry(): boolean {
  return getSessionStatus() === 'expired';
}
